import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from '../../../api/services/common.service';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';

@Component({
    selector: 'app-search-with-input-data',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './search-with-input-data.component.html',
    styleUrl: './search-with-input-data.component.css'
})
export class SearchWithInputDataComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  errors: { [key: string]: string } = {};
  loading: boolean = false;
  fieldsData: any;
  endpoint = environment.api_endpoint;
  formId: any = '692967217bbb342c1c4b1722';
  isLoading: boolean = false;
  constructor(private commonService: CommonService) {}

  ngOnInit() {
    // this.getData();
  }

  /** Function to get the data by api or static */
  getData() {
    this.formId = '692967217bbb342c1c4b1722';
    this.loadData(this.formId);
  }
  loadData(formId: any, pagination: { query: string } = { query: '' }) {
    this.loading = true;
    this.commonService.loadListWithOptions(formId, pagination).subscribe({
      next: (data) => {
        this.fieldsData = data.data.records || [];
        this.formGroup.patchValue({
          name: this.fieldsData[0].name,
        });
        this.loading = false;
        this.isLoading = false;
      },
      error: (err) => {
        this.fieldsData = [];
      },
    });
  }

  onKeyUpSearch(searchInput: any) {
    if (searchInput.length >= 3 || searchInput.length === 0) {
      this.isLoading = true;
      this.loadData(this.formId, { query: searchInput });
    }
  }

  get control() {
    return this.formGroup?.get(this.fields.fieldName);
  }

  /** Function to show the validation message on enter of the input fields */
  onKeyUpValidateFields(field: any): void {
    const fieldName = field.fieldName;
    const control = this.formGroup.get(fieldName);
    if (!control) return;
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
    this.errors[fieldName] = '';
    if (control.hasError('minlength')) {
      const minLengthRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'minlength',
      );
      this.errors[fieldName] =
        minLengthRule?.error ||
        `Minimum length is ${control.errors?.['minlength']?.requiredLength}.`;
      return;
    }

    if (control.hasError('maxlength')) {
      const maxLengthRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'maxlength',
      );
      this.errors[fieldName] =
        maxLengthRule?.error ||
        `Maximum length is ${control.errors?.['maxlength']?.requiredLength}.`;
      return;
    }

    if (control.hasError('pattern')) {
      const regexRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'regex',
      );
      this.errors[fieldName] = regexRule?.error || 'Invalid format.';
      return;
    }

    if (control.hasError('email')) {
      this.errors[fieldName] = 'Enter a valid email address.';
      return;
    }

    if (control.hasError('min')) {
      const minRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'min',
      );
      this.errors[fieldName] =
        minRule?.error || `Minimum value is ${control.errors?.['min']?.min}.`;
      return;
    }

    if (control.hasError('max')) {
      const maxRule = field.validationRules?.find(
        (v: any) => v.type.toLowerCase() === 'max',
      );
      this.errors[fieldName] =
        maxRule?.error || `Maximum value is ${control.errors?.['max']?.max}.`;
      return;
    }

    const dayAfterRule = field.validationRules?.find(
      (v: any) => v.type.toLowerCase() === 'dateafter',
    );
    if (
      dayAfterRule &&
      (fieldName.toLowerCase() === 'duedate' ||
        fieldName.toLowerCase() === 'startdate')
    ) {
      const startDateValue = this.formGroup.get('startDate')?.value;
      const dueDateControl = this.formGroup.get('dueDate');
      const dueDateValue = dueDateControl?.value;

      if (startDateValue && dueDateValue) {
        const startDate = new Date(startDateValue);
        const dueDate = new Date(dueDateValue);

        if (dueDate < startDate) {
          this.errors['dueDate'] =
            dayAfterRule.error || `End Date cannot be earlier than Start Date.`;
          dueDateControl?.setErrors({ dateAfter: true });
          return;
        } else {
          // ✅ Clear error if valid now
          if (dueDateControl?.hasError('dateAfter')) {
            const newErrors = { ...dueDateControl.errors };
            delete newErrors['dateAfter'];
            dueDateControl.setErrors(
              Object.keys(newErrors).length ? newErrors : null,
            );
          }
        }
      }
    }

    this.errors[fieldName] = '';
  }
}
